import styled from "styled-components";

export const AboutSection = styled.section`
  padding: 75px 0;
`;

export const AboutContent = styled.div`
  display: flex;
  gap: 60px;

  @media (max-width: 992px) {
    flex-direction: column;
    gap: 40px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  display: flex;
`;

export const AboutImage = styled.img`
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  object-fit: cover;

  @media (max-width: 992px) {
    max-width: unset;
  }
`;

export const TextWrapper = styled.div`
  flex: 1;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: baseline;
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.colors.primary};
  font-size: 16px;
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 0;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Rank = styled.p`
  font-size: 16px;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
`;

export const Description = styled.p`
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;

  &:last-of-type {
    margin-bottom: 2.5rem;
  }
`;

export const CTAButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 1.1rem;
  border-radius: 60px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  width: fit-content;

  &:hover {
    background: ${(props) => props.theme.colors.secondary};
  }
`;
